
import { useGetTransactionTypesQuery, useGetTransactionsQuery } from "../../services/PaymentToolApi";
import { useGetPurchaseQuickViewQuery } from "../../services/purchaseApi";
import JobPurchaseForm from "./components/jobPurchaseForm";
import JobPurchaseFormDisable from "./components/jobPurchaseFormDisable";
import JObPurchaseSkeleton from "./components/jobPurchaseFormSkeleton";

export default function JobPurchaseTab({ jobInfo, jobId }) {
  const { data: purchase, isLoading: jobPurchaseIsLoading, isError, error } = useGetPurchaseQuickViewQuery("?jobId=" + jobId);
  const {data: transactionTypes, isLoading: transactionTypesIsLoading, isError: transactionTypesIsError, error: transactionTypesError } = useGetTransactionTypesQuery();
  const { data: relatedTransactions, isLoading: RTisLoading, error: RTerror } = useGetTransactionsQuery( 
    { relatedTransactionID: purchase?.[0]?.transactionID, isDeleted: false }, 
    { skip: !purchase?.[0]?.transactionID } 
  );
  

  if(jobPurchaseIsLoading || transactionTypesIsLoading || RTisLoading ) return <JObPurchaseSkeleton />
  if(isError || transactionTypesIsError || RTerror) return <p>{error || transactionTypesError || RTerror}</p>
  if(purchase.length === 0) return <JobPurchaseFormDisable/>
  return(
    <>
      <JobPurchaseForm purchase={purchase[0]} transactionTypes={transactionTypes} relatedTransactions={relatedTransactions}/>
    </>
  )
}